export const normalizeLink = url =>
    url.match(/^https?:\/\//) ? url : `https://${url}`;
